module.exports = __webpack_public_path__ + "img/first-banner.c2330041.png";